// extracted by mini-css-extract-plugin
export default {"component-tab-view":"ComponentTabView_component-tab-view__chKbt"};